<template>
  <div class="container">
    <img
      src="//pic-cdn.bigdatajy.com/wenming/static/img/top.png"
      class="bg"
      alt=""
    />
    <div
      class="bt"
      @click="
        clickable = true;
        readonly = false;
      "
    >
      编辑
    </div>
    <div class="top">
      <img :src="imageUrl" class="icon" v-show="!clickable" alt="" />
      <el-upload
        v-show="clickable"
        class="avatar-uploader"
        action="/api/common/upload"
        :data="data"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img :src="imageUrl" class="avatar" />
      </el-upload>
      <div class="cameradiv">
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/camera.png"
          v-show="clickable"
          class="camera"
          alt=""
        />
      </div>
    </div>
    <!-- 基本信息 -->
    <div class="info">
      <div class="title">
        <span>基本信息</span>
      </div>
      <van-cell-group>
        <!-- <van-field v-model="obj.name" readonly label="昵称" /> -->
        <van-field v-model="myorg" readonly label="我管理的组织" />
        <!-- <van-field v-model="orgs" label="我加入的组织" /> -->
        <van-field
          readonly
          :clickable="clickable"
          label="我加入的组织"
          v-model="orgs"
          right-icon="arrow"
          :value="orgs"
          @click="orgsshowPicker = true && clickable"
        />
        <van-popup v-model="orgsshowPicker" round position="bottom">
          <van-picker
            show-toolbar
            value-key="name"
            :default-index="orgsdefaultindex"
            :columns="orgs_columns"
            @cancel="orgsshowPicker = false"
            @confirm="orgsonConfirm"
          />
        </van-popup>
      </van-cell-group>
    </div>
    <!-- 个人信息 -->
    <div class="info">
      <div class="title">
        <span>个人信息</span>
      </div>
      <van-cell-group>
        <van-field v-model="obj.name" readonly label="姓名" />
        <van-field
          v-model="politics_face"
          :clickable="clickable"
          readonly
          label="政治面貌"
          :value="politics_face"
          @click="politics_faceshowPicker = true && clickable"
          right-icon="arrow"
          ref="politics_face"
        />
        <van-popup v-model="politics_faceshowPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="politics_face_columns"
            :default-index="obj.politics_face - 1"
            value-key="value"
            @cancel="politics_faceshowPicker = false"
            @confirm="politics_faceonConfirm"
          />
        </van-popup>
        <van-field
          readonly
          :clickable="clickable"
          label="文化程度"
          v-model="wenhua"
          right-icon="arrow"
          :value="wenhua"
          @click="wenhuashowPicker = true && clickable"
        />
        <van-popup v-model="wenhuashowPicker" round position="bottom">
          <van-picker
            show-toolbar
            value-key="value"
            :default-index="obj.wenhua - 1"
            :columns="wenhua_columns"
            @cancel="wenhuashowPicker = false"
            @confirm="wenhuaonConfirm"
          />
        </van-popup>
        <!-- <van-field
          readonly
          label="所在城市"
          v-model="area"
          :value="area"
        /> -->
        <!-- <van-popup v-model="areashowPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="area_columns"
            value-key="name"
            @cancel="areashowPicker = false"
            @confirm="areaonConfirm"
            @change="areachange"
          />
        </van-popup> -->
        <van-field
          readonly
          :clickable="clickable"
          label="所在地区"
          v-model="street"
          :value="street"
          @click="streetshowPicker = true && clickable"
        />
        <van-popup v-model="streetshowPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="street_columns"
            value-key="name"
            @cancel="streetshowPicker = false"
            @confirm="streetonConfirm"
            @change="streetchange"
          />
        </van-popup>
        <van-field v-model="school" :readonly="readonly" label="毕业院校" />
        <van-field v-model="major" :readonly="readonly" label="专业" />
        <van-field v-model="compony" :readonly="readonly" label="工作单位" />
        <van-field
          v-model="compony_addr"
          :readonly="readonly"
          label="单位地址"
        />
        <van-field v-model="zhicheng" :readonly="readonly" label="职称" />
        <van-field v-model="zhiwu" :readonly="readonly" label="职务" />
        <van-field
          readonly
          :clickable="clickable"
          v-model="skill"
          rows="1"
          autosize
          label="个人技能"
          type="textarea"
          @click="skillshow = true && clickable"
        />
        <van-popup
          v-model="skillshow"
          position="bottom"
          :style="{ height: '50%' }"
        >
          <div class="flex">
            <p @click="skillshow = false">取消</p>
            <p @click="skillcomfirm">完成</p>
          </div>
          <van-checkbox-group style="margin-top: 15vw" v-model="result">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in list"
                clickable
                :key="item.index"
                :title="`${item.value}`"
                @click="toggle(index)"
              >
                <template #right-icon>
                  <van-checkbox
                    :name="`${item.id}-${item.value}`"
                    ref="checkboxes"
                  />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-popup>
      </van-cell-group>
    </div>
    <el-button type="warning" @click="save" v-show="clickable">保存</el-button>
  </div>
</template>
<script>
export default {
  name: "infochange",
  data() {
    return {
      clickable: false,
      readonly: true,
      imageUrl: "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png",
      imgchoose: "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png",
      data: { token: sessionStorage.getItem("wmtoken") },
      obj: {},
      member: "",
      nickname: "",
      myorg: "",
      orgs: "",
      username: "",
      politics_face: "",
      wenhua: "",
      edu: "",
      school: "",
      major: "",
      compony: "",
      compony_addr: "",
      zhicheng: "",
      zhiwu: "",
      skill: "",
      area: "江苏省江阴市",
      street: "江苏省江阴市",
      village: "",
      skillchoose: "",
      list: [
        {
          value: "外语",
          id: "1",
        },
        {
          value: "书法",
          id: "2",
        },
        {
          value: "绘画",
          id: "3",
        },
        {
          value: "电脑维修",
          id: "4",
        },
        {
          value: "文化辅导",
          id: "5",
        },
        {
          value: "编辑写作",
          id: "6",
        },
        {
          value: "话剧",
          id: "7",
        },
        {
          value: "演讲",
          id: "8",
        },
        {
          value: "节目主持",
          id: "9",
        },
        {
          value: "电脑编程",
          id: "10",
        },
        {
          value: "摄影",
          id: "11",
        },
        {
          value: "漫画",
          id: "12",
        },
        {
          value: "唱歌",
          id: "13",
        },
        {
          value: "推拿按摩",
          id: "14",
        },
        {
          value: "创意策划",
          id: "15",
        },
        {
          value: "处理应变",
          id: "16",
        },
        {
          value: "社交外联",
          id: "17",
        },
        {
          value: "人事管理",
          id: "18",
        },
        {
          value: "平面设计",
          id: "19",
        },
      ],
      result: [],
      orgsshowPicker: false,
      politics_faceshowPicker: false,
      wenhuashowPicker: false,
      skillshow: false,
      areashowPicker: false,
      streetshowPicker: false,
      orgs_columns: [],
      politics_face_columns: [
        {
          value: "中共党员",
          id: "1",
        },
        {
          value: "中共预备党员",
          id: "2",
        },
        {
          value: "共青团员",
          id: "3",
        },
        {
          value: "民革党员",
          id: "4",
        },
        {
          value: "民盟盟员",
          id: "5",
        },
        {
          value: "民建会员",
          id: "6",
        },
        {
          value: "民进会员",
          id: "7",
        },
        {
          value: "农工党党员",
          id: "8",
        },
        {
          value: "致公党党员",
          id: "9",
        },
        {
          value: "九三学社社员",
          id: "10",
        },
        {
          value: "台盟盟员",
          id: "11",
        },
        {
          value: "无党派人士",
          id: "12",
        },
        {
          value: "群众",
          id: "13",
        },
      ],
      wenhua_columns: [
        {
          value: "初中",
          id: "1",
        },
        {
          value: "高中",
          id: "2",
        },
        {
          value: "中技",
          id: "3",
        },
        {
          value: "中专",
          id: "4",
        },
        {
          value: "大专",
          id: "5",
        },
        {
          value: "本科",
          id: "6",
        },
        {
          value: "硕士",
          id: "7",
        },
        {
          value: "博士",
          id: "8",
        },
      ],
      street_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
      ],
      area_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column3",
        },
      ],
      areachoose: "320281",
      streetchoose: "",
      politics_facechoose: "",
      wenhuachoose: "",
      orgschoose: "",
      orgsdefaultindex: 0,
    };
  },
  created() {
    //console.log(sessionStorage.getItem('memberid'));
    var that = this;
    this.$axios({
      url: "/api/home/index",
      method: "post",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.obj = res.data.data.member;
        if (this.obj.img != "") {
          this.imageUrl = this.obj.img;
          this.imgchoose = this.obj.img;
        }
        if (res.data.data.fuze_org_list.length > 0) {
          this.myorg = res.data.data.fuze_org_list[0].name;
        }
        this.member = res.data.data.member.id;
        this.politics_face = this.obj.politics_face;
        this.wenhua = this.obj.wenhua;
        this.school = this.obj.school;
        this.major = this.obj.major;
        this.compony = this.obj.compony;
        this.compony_addr = this.obj.compony_addr;
        this.zhicheng = this.obj.zhicheng;
        this.zhiwu = this.obj.zhiwu;
        this.orgs_columns = res.data.data.org_list;
        console.log(this.orgs_columns);
        //重新赋值活动列表
        let arrorgs = [];
        for (var item in this.orgs_columns) {
          if (this.orgs_columns.hasOwnProperty(item)) {
            arrorgs.push(this.orgs_columns[item]);
          }
          if (this.obj.default_orgid == this.orgs_columns[item].id) {
          }
        }
        this.orgs_columns = arrorgs;
        for (let i in this.orgs_columns) {
          if (this.obj.default_orgid == this.orgs_columns[i].id) {
            this.orgs = this.orgs_columns[i].name;
            this.orgsdefaultindex = i;
            this.orgschoose = this.orgs_columns[i].id;
          }
        }
        //end
        //checkbox choose
        console.log(this.obj.skill.split(","), this.list[0]);
        let checkres = [];
        if (this.obj.skill != "") {
          for (let i in this.obj.skill.split(",")) {
            this.result.push(
              this.obj.skill.split(",")[i] +
                "-" +
                this.list[this.obj.skill.split(",")[i] - 1].value
            );
            checkres.push(this.list[this.obj.skill.split(",")[i] - 1].value);
          }
          this.skillchoose = this.obj.skill;
          this.skill = checkres.join(",");
        }
        //end
        for (let i in this.politics_face_columns) {
          if (this.politics_face_columns[i].id == this.politics_face) {
            this.politics_face = this.politics_face_columns[i].value;
            this.politics_facechoose = this.politics_face_columns[i].id;
          }
        }
        for (let i in this.wenhua_columns) {
          if (this.wenhua_columns[i].id == this.wenhua) {
            this.wenhua = this.wenhua_columns[i].value;
            this.wenhuachoose = this.wenhua_columns[i].id;
          }
        }
        //拉取地区选择
        console.log(this.obj.area, this.obj.street, this.obj.village);
        let area = this.obj.area;
        let street = this.obj.street;
        let village = this.obj.village;
        let areaarr = [],
          streetarr = [];
        areaarr.length = 3;
        this.$axios({
          url: "/api/common/area",
          method: "post",
          data: this.qs.stringify({
            code: area.slice(0, 4),
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          for (let i in res.data.data) {
            if (res.data.data[i].code == area) {
              areaarr[2] = res.data.data[i].name;
              console.log(areaarr);
              this.areachoose = res.data.data[i].code;
            }
          }
          this.locate(area.slice(0, 2)).then((res) => {
            console.log(res);
            for (let i in res) {
              if (res[i].code == area.slice(0, 4)) {
                areaarr[1] = res[i].name;
              }
            }
            this.locate("").then((res) => {
              console.log(res);
              for (let i in res) {
                if (res[i].code == area.slice(0, 2)) {
                  areaarr[0] = res[i].name;
                }
              }
              this.area = areaarr.join("/");
            });
          });
        });
        if (street != "") {
          this.locate(street.slice(0, 6)).then((res) => {
            for (let i in res) {
              if (res[i].code == street) {
                this.streetchoose = res[i].code;
                streetarr[0] = res[i].name;
              }
            }
            if (village != "") {
              this.locate(village.slice(0, 9)).then((res) => {
                for (let i in res) {
                  if (res[i].code == village) {
                    this.villagechoose = res[i].code;
                    streetarr[1] = res[i].name;
                  }
                }
                console.log(streetarr);
                this.street = "江苏省江阴市 " + streetarr.join("/");
              });
            }
          });
        }
      } else {
        this.$toast(res.data.msg);
      }
    });
    //乡村、镇、街道列表
    //省市区列表
    this.$axios({
      method: "post",
      url: "/api/common/area",
      data: this.qs.stringify({
        code: "",
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        that.locate("320281").then((res) => {
          that.street_columns[0].values = res;
          that.locate(that.street_columns[0].values[0].code).then((res) => {
            //that.street_columns[1].values = res;
            that.street_columns[0].values.unshift({ code: "", name: "不选择" });
            that.street_columns[1].values.unshift({ code: "", name: "不选择" });
          });
        });
      }
    });
  },
  methods: {
    handleAvatarSuccess(res, file) {
      console.log(res);
      console.log(file);
      this.imgchoose = file.response.data.url;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    streetonConfirm(value, index) {
      let arr = [];
      for (let i in value) {
        if (value[i].code != "") {
          arr.push(value[i].name);
        }
      }
      this.street = "江苏省江阴市 " + arr.join("/");
      this.streetshowPicker = false;
      console.log(value);
      this.streetchoose = value[0].code;
      this.villagechoose = value[1].code;
    },
    streetchange(picker, value, index) {
      if (value[0].code != "") {
        this.locate(value[0].code).then((res) => {
          res.unshift({ code: "", name: "不选择" });
          picker.setColumnValues(1, res);
          this.street_columns[1].defaultIndex = 0;
        });
      } else {
        picker.setColumnValues(1, [{ code: "", name: "不选择" }]);
        this.street_columns[1].defaultIndex = 0;
      }
    },
    areaonConfirm(value, index) {
      console.log(value);
      let arr = [];
      for (let i in value) {
        arr.push(value[i].name);
      }
      this.area = arr.join("/");
      this.areashowPicker = false;
      console.log(index);
      this.areachoose = value[2].code;
    },
    areachange(picker, value, index) {
      console.log(value, index);
      this.locate(value[0].code).then((res) => {
        picker.setColumnValues(1, res);
        this.area_columns[1].defaultIndex = 0;
        this.locate(picker.getValues()[1].code).then((res) => {
          picker.setColumnValues(2, res);
          this.area_columns[2].defaultIndex = 0;
        });
      });
    },
    //查询省市区
    locate(code) {
      return this.$axios({
        method: "post",
        url: "/api/common/area",
        data: this.qs.stringify({
          code: code,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          return res.data.data;
        }
      });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    skillcomfirm() {
      console.log(this.result);
      let skill = [];
      let result = [];
      for (let i in this.result) {
        skill.push(this.result[i].split("-")[1]);
      }
      console.log(skill);
      this.skill = skill.join(",");
      for (let i in this.result) {
        result[i] = this.result[i].split("-")[0];
      }
      console.log(result.join(","));
      this.skillchoose = result.join(",");
      this.skillshow = false;
    },
    politics_faceonConfirm(value, index) {
      console.log(index);
      this.politics_face = value.value;
      this.politics_facechoose = value.id;
      console.log(this.politics_face);
      this.politics_faceshowPicker = false;
    },
    wenhuaonConfirm(value, index) {
      this.wenhua = value.value;
      this.wenhuachoose = value.id;
      console.log(value);
      this.wenhuashowPicker = false;
    },
    orgsonConfirm(value, index) {
      console.log(value);
      this.orgs = value.name;
      this.orgschoose = value.id;
      this.orgsshowPicker = false;
    },
    save() {
      console.log(
        this.areachoose,
        this.streetchoose,
        this.villagechoose,
        this.skillchoose
      );
      this.$axios({
        method: "post",
        url: "/api/member/edit",
        data: this.qs.stringify({
          img: this.imgchoose,
          name: this.obj.name,
          politics_face: this.politics_facechoose,
          area: this.areachoose,
          street: this.streetchoose,
          village: this.villagechoose,
          skill: this.skillchoose,
          wenhua: this.wenhuachoose,
          school: this.school,
          major: this.major,
          compony: this.compony,
          compony_addr: this.compony_addr,
          zhicheng: this.zhicheng,
          zhiwu: this.zhiwu,
          default_orgid: this.orgschoose,
          id: this.member,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.clickable = false;
          this.readonly = true;
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.bg {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.bt {
  padding: 5px 15px;
  border-radius: 30px;
  border: 1px solid white;
  color: white;
  position: absolute;
  top: 10px;
  right: 10px;
}
.icon {
  width: 30vw;
  height: 30vw;
  border-radius: 50%;
  border: 5px solid white;
  display: block;
  margin: 0 auto;
  object-fit: cover;
}
.avatar-uploader {
  width: 30vw;
  height: 30vw;
  border-radius: 50%;
  border: 5px solid white;
  display: block;
  margin: 0 auto;
}
.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.top {
  margin: 25vw auto;
  position: relative;
  width: 30vw;
  margin-bottom: 10px;
}
.top .cameradiv {
  position: absolute;
  right: 0;
  bottom: 0;
}
.camera {
  width: 8vw;
}
.info {
  margin-bottom: 10px;
  padding: 10px;
}
.title {
  background: #f4f4f4;
  height: 25px;
}
.title span {
  background: #cab586;
  color: white;
  width: 35%;
  text-align: center;
  line-height: 25px;
  height: 25px;
  display: inline-block;
}
.el-button {
  background: #cab586;
  border: 0;
  margin: 20px auto;
  display: block;
  width: 50%;
}
.flex {
  display: flex;
  justify-content: space-between;
  padding: 5vw;
  position: fixed;
  z-index: 99;
  width: 90vw;
  background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/infochange.vue